// @flow @jsx h

import { Slideshow, ViewportIntersections } from '@nrk/dh-feature-components'
import { getScrollTop } from '@nrk/dh-utils'
import { h } from 'preact'
import PureComponent from 'preact-pure-component'
import style from './index.css'
import MediaSlide from './MediaSlide'

// Import card types
import FactBoxCard from './cards/FactBoxCard'
import DefaultCard from './cards/DefaultCard'

import type { Props, State } from './types'

type Intersection = {
  isIntersecting: boolean,
  ratio: number
}

class VisualStory extends PureComponent<Props, State> {
  elm: HTMLDivElement
  visibleRaf: any

  constructor (props: Props) {
    super(props)

    this.state = {
      intersectionRatio: 0,
      rect: null,
      visibleIndex: props.slides.length ? 0 : -1,
      visible: false
    }
  }

  componentDidMount () {
    this.handleResize()

    this.props.onRegisterTriggerElement(
      this.elm,
      this.props.sectionIndex,
      this.props.index
    )

    window.addEventListener('resize', this.handleResize)

    // if (this.props.isIntersecting) {
    //   console.log('isIntersecting')
    // }
  }

  componentDidUpdate (prevProps: Props, prevState: State) {
    const { isIntersecting } = this.props
    // const { rect } = this.state

    // if (rect !== prevState.rect) {
    //   console.log('rect changed', rect)
    // }

    if (isIntersecting !== prevProps.isIntersecting) {
      if (isIntersecting && !prevProps.isIntersecting) {
        // console.log('start listener')
        this.startVisibilityListener()
      } else {
        this.stopVisibilityListener()
        // console.log('stop listener')
      }
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    const scrollTop = getScrollTop()
    const rect = this.elm.getBoundingClientRect()

    // console.log(scrollTop)

    this.setState({
      rect: {
        height: rect.height,
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop
      }
    })
  }

  handleChange = (intersections: Intersection[]) => {
    this.setState({
      intersectionRatio: intersections[this.state.visibleIndex].ratio
    })
  }

  handleEnter = (entry: any, idx: number) => {
    this.setState({ visibleIndex: idx })
  }

  startVisibilityListener () {
    const { rect, visible } = this.state
    const scrollTop = getScrollTop()
    const halfHeight = window.innerHeight / 2

    if (rect) {
      if (
        scrollTop > rect.top - halfHeight &&
        scrollTop < rect.bottom - halfHeight
      ) {
        if (!visible) {
          this.setState({ visible: true })
        }
      } else {
        if (visible) {
          this.setState({ visible: false })
        }
      }
    }

    this.visibleRaf = requestAnimationFrame(() => {
      this.startVisibilityListener()
    })
  }

  stopVisibilityListener () {
    if (this.visibleRaf) {
      // console.log('stop listener')
      cancelAnimationFrame(this.visibleRaf)
    }
  }

  render () {
    const {
      isIntersecting,
      mediaBaseUrl,
      muted,
      onAnalyticsEvent,
      onToggleMute,
      slides,
      viewport
    } = this.props
    const { intersectionRatio, visible, visibleIndex } = this.state

    const cardsInlineStyle = {}

    if (viewport.height > -1) {
      cardsInlineStyle.marginTop = `${0 - viewport.height}px`
      cardsInlineStyle.paddingBottom = `${viewport.height}px`
    }

    return (
      <div ref={elm => (this.elm = elm)} className={style.visualStory}>
        <Slideshow
          className={style.visualStory__slideshow}
          visibleIndex={visibleIndex}
          viewport={viewport}
        >
          {slides.map((slide, idx) => (
            <MediaSlide
              {...slide}
              key={String(idx)}
              intersectionRatio={intersectionRatio}
              mediaBaseUrl={mediaBaseUrl}
              muted={muted}
              onAnalyticsEvent={onAnalyticsEvent}
              onToggleMute={onToggleMute}
              viewport={viewport}
              visible={visible && isIntersecting && idx === visibleIndex}
            />
          ))}
        </Slideshow>
        <ViewportIntersections
          className={style.visualStory__cards}
          onChange={this.handleChange}
          onEnter={this.handleEnter}
          threshold={[0, 0.5, 1]}
          style={cardsInlineStyle}
        >
          {slides.map((slide, idx) => {
            switch (slide.type) {
              case 'factBoxSlide':
                return (
                  <FactBoxCard
                    {...slide}
                    key={String(idx)}
                    viewport={viewport}
                  />
                )
              default:
                return (
                  <DefaultCard
                    {...slide}
                    key={String(idx)}
                    viewport={viewport}
                  />
                )
            }
          })}
        </ViewportIntersections>
      </div>
    )
  }
}

export default VisualStory
